import { render, staticRenderFns } from "./PApp.vue?vue&type=template&id=20048fc0&"
import script from "./PApp.vue?vue&type=script&lang=js&"
export * from "./PApp.vue?vue&type=script&lang=js&"
import style0 from "./PApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PApp.vue"
export default component.exports